export default {
      id: "arrow-right-builder-usage",
      viewBox: "0 0 19 20",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#arrow-right-builder",
      toString: function () {
        return this.url;
      }
    }